import qs from 'qs';
import { ParsedUrlQueryInput } from 'querystring';
import { UrlObject } from 'url';

export const SIMILAR_STUDY_ITEM_URL_PREFIX = '/manage/similar-study-item';
export const MANAGE_STORAGE_URL_PREFIX = '/manage/study-item-storage';

export const getSimilarProblemsSelectPageUrlObject = (): UrlObject => {
  const urlString = `${SIMILAR_STUDY_ITEM_URL_PREFIX}/select-study-material`;
  return { pathname: urlString };
};

export const getSimilarStudyItemsFromStudyMaterialPageUrlObject = (
  studyMaterialId: number,
): UrlObject => {
  const urlString = `${SIMILAR_STUDY_ITEM_URL_PREFIX}/analysis/study-material/${studyMaterialId}`;
  return { pathname: urlString };
};

export const getSimilarStudyItemsFromStudyItemsPageUrlObject = (query: {
  studyItemIds: number[];
}): UrlObject => {
  const urlString = `${MANAGE_STORAGE_URL_PREFIX}/analysis`;
  const queryString = qs.stringify(query, {
    skipNulls: true,
    arrayFormat: 'comma',
    encodeValuesOnly: true,
  });
  const parsedUrlQuery = qs.parse(queryString);
  return { pathname: urlString, query: parsedUrlQuery as ParsedUrlQueryInput };
};

export const getManageStudyItemStoragePageUrlObject = (query?: {
  classificationValue?: number | string;
}): UrlObject => {
  const urlString = MANAGE_STORAGE_URL_PREFIX;
  return { pathname: urlString, query };
};

export const getStudyItemEditPageUrlObject = (
  studyItemId: number,
): UrlObject => {
  const urlString = `${MANAGE_STORAGE_URL_PREFIX}/edit/${studyItemId}`;
  return { pathname: urlString };
};

export const getStudyMaterialListPage = (): UrlObject => {
  return { pathname: '/manage/material-list' };
};
